/**
 * Timelines API Service
 *
 * Handles all API calls for the Times page
 * Following the same pattern as GameApiService
 */
import axios from 'axios';
import { HOST_URL, API_V2 } from '@/config/api';

/**
 * Timelines API Service class
 */
export class TimelinesApiService {
  constructor(baseUrl = HOST_URL) {
    this.baseUrl = baseUrl;
    this.http = axios.create({ baseURL: baseUrl });
  }

  /**
   * Fetch timelines data for a group
   * @param {string} groupId - Group ID
   * @param {string} lineId - LINE user ID
   * @returns {Promise<Object>} Timelines response data
   */
  async getTimelines(groupId, lineId) {
    const effectiveGroupId = groupId || lineId;
    const response = await this.http.get(
      `${API_V2}/groups/${effectiveGroupId}/timelines?line_id=${lineId}`
    );
    return response.data;
  }
}

// Default instance
export const timelinesApiService = new TimelinesApiService();

/**
 * Composable hook for using Timelines API in Vue components
 * @param {Object} options - Configuration options
 * @returns {Object} API methods
 */
export function useTimelinesApi(options = {}) {
  const service = options.service || timelinesApiService;

  return {
    /**
     * Fetch timelines data
     * @param {string} groupId - Group ID
     * @param {string} lineId - LINE user ID
     * @returns {Promise<Object>} Timelines data
     */
    async fetchTimelines(groupId, lineId) {
      return service.getTimelines(groupId, lineId);
    }
  };
}

export default timelinesApiService;
